(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.factory('DayService', ['$rootScope', '$filter', '$uibModal', 'DaySchemeTime', 'DayStartEndTime', 'SchemeBroadcast', 'SharedAgendaService', DayServiceFn]);

    /* service representing day and its times */
    function DayServiceFn($rootScope, $filter, $uibModal, DaySchemeTime, DayStartEndTime, SchemeBroadcast, SharedAgendaService) {

        // current day with parts (morning, afternoon, evening)
        var weekday = {
            morning: {
                name: 'morning',
                times: [],
                basic: [] // times just of the weekscheme
            }, // list of times
            afternoon: {
                name: 'afternoon',
                times: [],
                basic: [] // times just of the weekscheme
            },
            evening: {
                name: 'evening',
                times: [],
                basic: [] // times just of the weekscheme
            }
        };

        var service = {
            init: init,
            day: day,
            set: set,
            remove: remove,
            removeAll: removeAll,
            removeTime: removeTime,
            setAll: setAll,
            select: select,
            list: list,
            showModal: showModal
        };

        // public data
        service.data = {
            keyDown: false, // is left mouse key down
            label: {}, // currently selected label
            interval: 0, // agenda interval
            valid: false // status of day -> are there any selected labels to save ?
        };

        return service;

        // generate day -> split in day-parts
        function generate(day, timesOfWeekschemes) {
            weekday.morning.times = [];
            weekday.afternoon.times = [];
            weekday.evening.times = [];
            weekday.morning.basic = [];
            weekday.afternoon.basic = [];
            weekday.evening.basic = [];

            // minutes to add
            var minutes = service.data.interval;

            // start/current time
            var now = new Date();
            now.setHours(DayStartEndTime.Start.hour);
            now.setMinutes(DayStartEndTime.Start.minute);
            now.setSeconds(0);
            now.setMilliseconds(0);

            // end time
            var end = new Date();
            end.setHours(DayStartEndTime.End.hour);
            end.setMinutes(DayStartEndTime.End.minute);
            end.setSeconds(0);


            // iterate till 21:00 pm reached
            while (now < end) {
                // new day scheme time object
                var time = new DaySchemeTime();
                time.init(now.getHours(), now.getMinutes());
                // Basic Time
                var basic = new DaySchemeTime();
                basic.init(now.getHours(), now.getMinutes());

                // iterate over existing times set to proof if time exists
                var found = false;

                var j = 0;
                var len = day.times.length;
                for (j = 0; j < len; j++) {
                    if (day.times[j] === null) { continue; }
                    // identical ?
                    if (now.getHours() === day.times[j].hour
                        && now.getMinutes() === day.times[j].minute) {
                        // found...
                        found = true;

                        // extend object
                        time.extend(day.times[j]);
                        time.canDelete = true;

                        // remove object - so no more iterating 
                        day.times[j] = null;

                        break;
                    } //if
                } // for

                // Find Basic-WeekScheme-Time
                if (timesOfWeekschemes !== undefined) {
                    var t = 0;
                    var wlen = timesOfWeekschemes.length;
                    for (t; t < wlen; t++) {
                        var wt = timesOfWeekschemes[t];
                        // compare time
                        if (wt === null) { continue; }
                        if (now.getHours() === wt.hour && now.getMinutes() === wt.minute) {
                            // found 
                            //basic = wt;

                            // If Extra-Time was found -> make basic from Weekscheme
                            // If Not -> Basic And Normal from Weekscheme
                            if (found) {
                                basic.copy(wt);
                                basic.vmOnlyShow = true;
                            } // if
                            else {
                                // current time
                                time.copy(wt);
                                time.vmOnlyShow = true; // no saving in backend

                                basic.copy(time);
                            } // else

                            wt = null;
                            timesOfWeekschemes[t] = null;

                            break;
                        } // if                        
                    } //for
                } // if


                // put in right part of day
                // depend on time split in parts  
                if (time.hour >= DayStartEndTime.Start.hour && time.hour < 12) {
                    // moring from 06:00 - > 11:45
                    weekday.morning.times.push(time);
                    weekday.morning.basic.push(basic);                    
                } //if
                else if (time.hour >= 12 && time.hour < 18) {
                    // afternoon from 12 to 18
                    weekday.afternoon.times.push(time);
                    weekday.afternoon.basic.push(basic);
                } // else if
                else {
                    // evening from 18 to 24
                    weekday.evening.times.push(time);
                    weekday.evening.basic.push(basic);
                } //else


                // add minutes
                now.setMinutes(now.getMinutes() + minutes);
            } // while

            day.times = null;
        } // generate

        // init service
        function init(day, timesOfWeekschemes, interval) {
            // set interval
            service.data.interval = interval;

            // generate
            generate(day, timesOfWeekschemes);

            // validate 
            valid(list());
        } // init

        // set label to selected part 
        function set(part) {
            // select all times of part
            part.times.forEach(function (cell) {
                // default set "selected" to no -> so it gets selected
                // cell.vmSelected = false;
                select(cell);
            });
            $rootScope.$broadcast(SchemeBroadcast.DaySelected);
        }

        // set label to whole day
        function setAll() {
            removeAll();
            set(weekday.morning);
            set(weekday.afternoon);
            set(weekday.evening);
        }

        function removeTime(event, time, part) {
            event.preventDefault();
            event.stopImmediatePropagation();

            var index = part.times.indexOf(time);

            // find original weekscheme timeslot
            var weekschemeTime = part.basic.filter(function(original) {
                return original.hour === time.hour && original.minute === time.minute
            })[0];

            var weekschemeTimeCopy = new DaySchemeTime();
            weekschemeTimeCopy.copy(weekschemeTime);
            part.times[index] = weekschemeTimeCopy;            
        }

        // remove all the items on that part
        function remove(part) {            
            // set back to basic
            part.times = [];

            part.basic.forEach(function (item) {
                var basic = new DaySchemeTime();
                basic.copy(item);
                part.times.push(basic);
            });

            // validate list
            valid(list());
            $rootScope.$broadcast(SchemeBroadcast.DaySelected);
        }

        // remove all
        function removeAll() {
            remove(weekday.morning);
            remove(weekday.afternoon);
            remove(weekday.evening);
        }

        // select a cell and set label
        function select(cell) {

            cell.agendaLabelDto = service.data.label;
            cell.vmOnlyShow = false;
            cell.canDelete = true;

            // // select
            // cell.vmSelected = !cell.vmSelected;
            // // now persist !
            // cell.vmOnlyShow = false;
            // // label
            // if (cell.vmSelected) {
            //     // label
                
            // } //If
            // else {
            //     cell.agendaLabelDto = null;
            // } // else

            // validate list
            valid(list());
        } // select

        //get weekday
        function day() {
            return weekday;
        }

        // return list of times -> just times without related weekscheme
        function list() {
            var list = weekday.morning.times.concat(weekday.afternoon.times.concat(weekday.evening.times));
            // filter -> remove items which are only for showing
            list = $filter('filter')(list, { vmOnlyShow: false }, true);
            return list;
        }


        // check validation
        function valid(times) {
            var i = 0;
            var len = times.length;
            for (i = 0; i < len; i++) {
                if (times[i].agendaLabelDto) {
                    service.data.valid = true;
                    return;
                }//if
            } //for
            service.data.valid = false;
        } // valid


        // open modal and show item, get user as parameter and not from SharedAgendaService, because in the agenda-view 
        // the selected agenda doesn't have to be the same as the selected client in the service
        function showModal(date, dateEditable, userId) {
            // open modal
            return $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/settings/agendasettings/modules/extradaysholidays/templates/days-detail.template.html',
                controller: 'ExtraDaysHolidaysDetailController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    labels: ['AgendaLabelService', function (AgendaLabelService) {
                        return AgendaLabelService.query(SharedAgendaService.getAgendaByOwner(userId).id, false);
                    }],
                    interval: ['AgendaService', function (AgendaService) {
                        return SharedAgendaService.getAgendaByOwner(userId).interval;
                    }],
                    dateEditable: function () {
                        return dateEditable;
                    },
                    userId: function () {
                        return userId;
                    },
                    date: function () {
                        return date;
                    }
                }
            });
        } // showModal
    }
})();